module.exports = __webpack_public_path__ + "img/logo.99a179a6.jpg";